import { SESSION_STORAGE_KEY } from './helpers/constants.js';
const ORIGINAL_URL_TYPE_EXTERNAL = "external";
const ORIGINAL_URL = SESSION_STORAGE_KEY.originalUrl;
const ORIGINAL_URL_TYPE = SESSION_STORAGE_KEY.originalUrlType;
const LOGIN_REDIRECT = SESSION_STORAGE_KEY.loginAutoRedirect;
const saveOriginalUrlBeforeLogin = function () {
  let isExternalSite = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  let redirectToLoginDirectly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let url = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  const pathname = window.location.pathname;
  if (pathname !== "/" && pathname !== "/login" && pathname !== "/logout") {
    clearOriginalUrl();
    sessionStorage.setItem(ORIGINAL_URL, url ? url : window.location.pathname + window.location.hash + window.location.search);
    if (isExternalSite) {
      sessionStorage.setItem(ORIGINAL_URL_TYPE, ORIGINAL_URL_TYPE_EXTERNAL);
    }
    if (redirectToLoginDirectly) {
      sessionStorage.setItem(LOGIN_REDIRECT, "Y");
    }
  }
};
const clearOriginalUrl = () => {
  sessionStorage.removeItem(ORIGINAL_URL);
  sessionStorage.removeItem(ORIGINAL_URL_TYPE);
  sessionStorage.removeItem(LOGIN_REDIRECT);
};
const hasOriginalUrl = () => {
  return !!sessionStorage.getItem(ORIGINAL_URL);
};
const isLoginDirectly = () => {
  return !!sessionStorage.getItem(LOGIN_REDIRECT);
};
const popOriginalUrl = () => {
  const originalUrl = sessionStorage.getItem(ORIGINAL_URL);
  const originalUrlType = sessionStorage.getItem(ORIGINAL_URL_TYPE);
  if (originalUrl || originalUrlType) {
    sessionStorage.removeItem(ORIGINAL_URL);
    sessionStorage.removeItem(ORIGINAL_URL_TYPE);
    sessionStorage.removeItem(LOGIN_REDIRECT);
  }
  return {
    url: originalUrl,
    isExternal: originalUrlType === ORIGINAL_URL_TYPE_EXTERNAL
  };
};
export { clearOriginalUrl, hasOriginalUrl, isLoginDirectly, popOriginalUrl, saveOriginalUrlBeforeLogin };